export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13741.718078a5.jpg";